import React, { useState, useContext } from "react";
import "./Products.scss";
import { Col, Row, Tooltip } from "antd";
import { PiHeartFill } from "react-icons/pi";
import { formatNumber } from "../../helper/fomartNum";
import Modal_No_Login from "../Modal_No_Login";
import { getCookie } from "../../helper/cookie";
import { Link } from "react-router-dom";
import { UserContext } from "../../context/userContext";
import { patchUserLike } from "../../services/user/user";
import { priceNew } from "../../helper/priceNew";

function Products({ productsFiltered }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const token = getCookie("token");
  const { currentUser, setCurrentUser } = useContext(UserContext);

  const handleCancel = () => setIsModalOpen(false);

  const handleActiveLove = async (product) => {
    if (!currentUser) return;

    const isLiked = currentUser.liked?.includes(product.idProducts);
    const newLiked = isLiked
      ? currentUser.liked.filter((id) => id !== product.idProducts)
      : [...currentUser.liked, product.idProducts];

    await patchUserLike(currentUser.id, newLiked);
    setCurrentUser({ ...currentUser, liked: newLiked });
  };

  const isProductLiked = (product) =>
    currentUser?.liked?.includes(product.idProducts);

  return (
    <div className="products">
      <Row gutter={[20, 20]}>
        {productsFiltered
          ?.filter((p) => p.stock === true)
          .map((p) => (
            <Col key={p.idProducts} xxl={6} xl={6} lg={6} md={6} sm={8} xs={12}>
              <Link to={`/products/${p.idProducts}`}>
                <div className="products-item">
                  <img src={p.thumbnail1} alt="Image" className="img" />
                  <img src={p.thumbnail2} alt="Image" className="img-abs" />

                  <div className="products-item-name">{p.name}</div>
                  <div className="products-item-size">{p.size}</div>

                  <div className="products-item-sales">-{p.sales}%</div>

                  <div className="products-item-price">
                    <div className="price_new">
                      {formatNumber(priceNew(p.price_old, p.sales))}
                      <span className="underline">đ</span>
                    </div>

                    <del className="price_old">
                      {formatNumber(p.price_old)}
                      <span className="underline">đ</span>
                    </del>
                  </div>

                  <Tooltip title="Thích">
                    <PiHeartFill
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (!token) {
                          setIsModalOpen(true);
                          return;
                        }
                        handleActiveLove(p);
                      }}
                      className={`iconLove ${
                        isProductLiked(p) ? "active" : ""
                      }`}
                    />
                  </Tooltip>
                </div>
              </Link>
            </Col>
          ))}
      </Row>

      <Modal_No_Login isModalOpen={isModalOpen} handleCancel={handleCancel} />
    </div>
  );
}

export default Products;
